import React from 'react';
import {
  DashboardLineChart,
  DashboardBarChart,
  DashboardAreaChart,
  DashboardPieChart,
  DashboardDonutChart,
  DashboardComboChart,
  COLORS,
} from '../../../components/charts/DashboardCharts';

// Sample data generators - replace with real API data
const generateMonthlyData = () => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months.map(month => ({
    name: month,
    revenue: Math.floor(Math.random() * 100000) + 50000,
    expenses: Math.floor(Math.random() * 80000) + 30000,
    profit: Math.floor(Math.random() * 50000) + 10000,
  }));
};

const generateProjectStatusData = () => [
  { name: 'Completed', value: 45 },
  { name: 'In Progress', value: 30 },
  { name: 'Pending', value: 15 },
  { name: 'On Hold', value: 10 },
];

const generateDepartmentData = () => [
  { name: 'IT', employees: 25, budget: 500000 },
  { name: 'HR', employees: 15, budget: 300000 },
  { name: 'Finance', employees: 20, budget: 400000 },
  { name: 'Sales', employees: 35, budget: 600000 },
  { name: 'Marketing', employees: 18, budget: 350000 },
];

const generateTaskStatusData = () => [
  { name: 'Todo', value: 120 },
  { name: 'In Progress', value: 85 },
  { name: 'Review', value: 45 },
  { name: 'Completed', value: 230 },
];

const generateQuarterlyData = () => [
  { name: 'Q1', sales: 45000, target: 50000 },
  { name: 'Q2', sales: 52000, target: 55000 },
  { name: 'Q3', sales: 48000, target: 53000 },
  { name: 'Q4', sales: 61000, target: 60000 },
];

// Revenue Trend Chart
export const RevenueTrendChart = ({ data }) => {
  const chartData = data || generateMonthlyData();
  
  return (
    <DashboardAreaChart
      data={chartData}
      dataKeys={[
        { key: 'revenue', name: 'Revenue' },
        { key: 'expenses', name: 'Expenses' },
        { key: 'profit', name: 'Profit' },
      ]}
      title="Revenue Trend (Last 12 Months)"
      height={350}
      colors={[COLORS.success[0], COLORS.danger[0], COLORS.primary[0]]}
    />
  );
};

// Project Status Chart
export const ProjectStatusChart = ({ data }) => {
  const chartData = data || generateProjectStatusData();
  
  return (
    <DashboardPieChart
      data={chartData}
      title="Project Status Distribution"
      height={300}
      colors={[COLORS.success[0], COLORS.primary[0], COLORS.warning[0], COLORS.danger[0]]}
    />
  );
};

// Department Overview Chart
export const DepartmentOverviewChart = ({ data }) => {
  const chartData = data || generateDepartmentData();
  
  return (
    <DashboardBarChart
      data={chartData}
      dataKeys={[
        { key: 'employees', name: 'Employees' },
        { key: 'budget', name: 'Budget (₦)' },
      ]}
      title="Department Overview"
      height={350}
      colors={[COLORS.primary[0], COLORS.success[0]]}
    />
  );
};

// Task Status Chart
export const TaskStatusChart = ({ data }) => {
  const chartData = data || generateTaskStatusData();
  
  return (
    <DashboardDonutChart
      data={chartData}
      title="Task Status"
      height={300}
      colors={[COLORS.warning[0], COLORS.primary[0], COLORS.purple[0], COLORS.success[0]]}
    />
  );
};

// Sales Performance Chart
export const SalesPerformanceChart = ({ data }) => {
  const chartData = data || generateQuarterlyData();
  
  return (
    <DashboardComboChart
      data={chartData}
      barKeys={[{ key: 'sales', name: 'Actual Sales' }]}
      lineKeys={[{ key: 'target', name: 'Target' }]}
      title="Quarterly Sales Performance"
      height={350}
    />
  );
};

// Monthly Comparison Chart
export const MonthlyComparisonChart = ({ data }) => {
  const chartData = data || generateMonthlyData();
  
  return (
    <DashboardLineChart
      data={chartData}
      dataKeys={[
        { key: 'revenue', name: 'Revenue' },
        { key: 'expenses', name: 'Expenses' },
      ]}
      title="Monthly Financial Comparison"
      height={350}
      colors={[COLORS.success[0], COLORS.danger[0]]}
    />
  );
};

// All Charts Component - displays all available charts
export const AllAnalyticsCharts = () => {
  return (
    <div className="space-y-6">
      {/* Row 1: Revenue and Project Status */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <RevenueTrendChart />
        <ProjectStatusChart />
      </div>

      {/* Row 2: Department Overview */}
      <DepartmentOverviewChart />

      {/* Row 3: Task Status and Sales Performance */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <TaskStatusChart />
        <SalesPerformanceChart />
      </div>

      {/* Row 4: Monthly Comparison */}
      <MonthlyComparisonChart />
    </div>
  );
};

export default {
  RevenueTrendChart,
  ProjectStatusChart,
  DepartmentOverviewChart,
  TaskStatusChart,
  SalesPerformanceChart,
  MonthlyComparisonChart,
  AllAnalyticsCharts,
};
